module.exports = __webpack_public_path__ + "static/media/instagram.aa828d39.svg";